import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/projectmanagers/';
    const paths = {
        endpointSave: config.endpoints.backend + 'projectmanagers/save',
        endpointGetById: config.endpoints.backend + 'projectmanagers/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Gestor de Projeto",
        labelTitleEdit: "Editar Gestor de Projeto",
        labelTitleView: 'Visualizar Gestor de Projeto'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'projects',
                    type: 'multiinput',
                    label: 'Projetos',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_project_id',
                            type: 'select',
                            label: 'Projeto',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjects,
                                label: 'project_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        },
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'cpf',
                    type: 'CPF',
                    label: 'CPF',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    label: 'Tipo de Endereço',
                    type: 'select',
                    options: [
                        {
                            label: "Comercial",
                            value: "COMERCIAL"
                        },
                        {
                            label: "Residencial",
                            value: "RESIDENCIAL"
                        }
                    ],
                    name: 'type_address',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto',
                    uploadPath: '/businessmanagers/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'login',
                    type: 'text',
                    label: 'Login',
                    validations: {
                        required: true,
                        login: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password',
                    type: 'password',
                    label: 'Senha',
                    validations: {
                        password: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password_confirm',
                    type: 'password',
                    label: 'Repetir senha',
                    validations: {
                        password_confirm: true
                    },
                    columnSize: 12
                },
                {
                    name: 'birth_date',
                    type: 'date',
                    label: 'Data de Nascimento',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'rg',
                    type: 'RG',
                    label: 'RG',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'social_name',
                    type: 'text',
                    label: 'Nome Social',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'gender',
                    type: 'select',
                    label: 'Gênero',
                    options: [
                        { label: 'Masculino', value: 'M' },
                        { label: 'Feminino', value: 'F' },
                        { label: 'Não Identificar', value: 'NI' },
                        { label: 'Ignorado', value: 'I' },
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'phones',
                    type: 'multiinput',
                    label: 'Contatos',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Tipo',
                            type: 'select',
                            options: [{
                                label: "Tel. Institucional",
                                value: "TELINSTITUCIONAL"
                            },
                            {
                                label: "Tel. Fixo",
                                value: "TELFIXO"
                            },
                            {
                                label: "Recado",
                                value: "RECADO"
                            },
                            {
                                label: "Comercial",
                                value: "COMERCIAL"
                            },
                            {
                                label: "Residencial",
                                value: "RESIDENCIAL"
                            },
                            {
                                label: "Celular",
                                value: "CELULAR"
                            }],
                            name: 'type',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Telefone',
                            type: 'phone',
                            name: 'phone',
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'emails',
                    type: 'multiinput',
                    label: 'Emails',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Tipo',
                            type: 'select',
                            options: [{
                                label: "Institucional",
                                value: "INSTITUCIONAL"
                            },
                            {
                                label: "Pessoal",
                                value: "PESSOAL"
                            },
                            {
                                label: "Comercial",
                                value: "COMERCIAL"
                            }],
                            name: 'type',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Email',
                            type: 'email',
                            name: 'email',
                            maxLength: 100,
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                password: (value, options, key, attributes) => {
                    if (value.length < 8 && value.length > 0) {
                        return '^A senha deve ter no minímo 8 caracteres';
                    } else {
                        return '';
                    }
                },
                password_confirm: (value, options, key, attributes) => {
                    if (value !== attributes.password_confirm) {
                        return '^O campo repetir senha deve ter igual ao campo senha';
                    } else {
                        return '';
                    }
                },
                login: async (value, options, key, attributes) => {
                    const checkLogin = async (value) => {
                        let post = {
                            login: value
                        };

                        if (id) {
                            const post_manager = {
                                id
                            };

                            const manager = await Fetch.post(config.endpoints.backend + 'projectmanagers/getById', post_manager);
                            post.user_id = manager.core_user_id;
                        }

                        if (value.trim().length > 2) {
                            let response = await Fetch.post(config.endpoints.backend + 'core/users/getbylogin', post);
                            if (response.id) {
                                return '^O login já está sendo utilizado por outro usuário';
                            }
                        }

                        return "";
                    }
                    return checkLogin(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
